import { render } from "./SaveQualificationEducation.vue?vue&type=template&id=5b47bacc"
import script from "./SaveQualificationEducation.vue?vue&type=script&lang=js"
export * from "./SaveQualificationEducation.vue?vue&type=script&lang=js"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__